import { Select } from "@mantine/core";

interface StatusCellProps {
  statusValue?: boolean;
  onChange: (newValue: boolean) => void;
}

const PARTICIPATION_CHOICES = [
  { label: "Ja", value: "true" },
  { label: "Nein", value: "false" }
];

function StatusCell({ statusValue, onChange }: StatusCellProps) {
  return (
    <Select
      data={PARTICIPATION_CHOICES}
      defaultValue={statusValue ? "true" : "false"}
      name="participationsInMieterstromModel"
      required
      onChange={(value) => onChange(value === "true")}
    />
  );
}

export { StatusCell };
